// extracted by mini-css-extract-plugin
module.exports = {"pdf":"pdf__-qeXO","pdf__document":"pdf__document__2uCm_","pdf__loader":"pdf__loader__3m9iY"};